import React, { useEffect, useState } from 'react'
import { NavigationStackScreenComponent } from 'react-navigation-stack'
import { CustomHeader } from '../../components/CustomHeader'
import { formatMessage } from '../../constants/strings/intl/intlHooks'
import { messages } from '../../constants/strings/messages'
import { Coordinator } from '../../navigation/coordinator/coordinator'
import { NotificationSwipeableList } from '../Dashboard/NotificationSwipeableList'
import { getNotifications } from '../../services/main/getNotifications'
import { useGlobal } from '../../global/useGlobal'
import { Loading } from '../../components/loading/Loading'
import { ATLSpacing, SpacingSizesEnum } from '@appsimples/atlantica-react-native'
import { AppModules } from '../../constants/AppModules'
import { notificationMock } from '../../services/mocks/notificationMock'
import { FeatureManager } from '../../FeatureManager'
import { usePromise } from '../../utils/hooks/usePromise'

export const NotificationsScreen: NavigationStackScreenComponent = () => {
  const [notifications] = useGlobal('notificationsList')

  const { loading: isGettingNotification, request: requestNotificationsList } = usePromise(getNotifications)

  const getNotificationsList = () => {
    requestNotificationsList()
  }

  useEffect(() => {
    getNotificationsList()
  }, [])

  const notificationsList = notifications?.filter(notification => {
    return notification.group !== AppModules.Custom
  })

  const data = FeatureManager.useNotificationMock ? notificationMock : notificationsList

  return isGettingNotification || !data ? (
    <>
      <ATLSpacing type={SpacingSizesEnum.marginal} />
      <Loading />
    </>
  ) : (
    <NotificationSwipeableList data={data} />
  )
}
NotificationsScreen.navigationOptions = CustomHeader(formatMessage(messages.notificationsScreen_header), true, () =>
  Coordinator.goBack()
)
